module.exports = "/_next/static/resources/photo-4-6e839e46c32830b18259d929436f3c91.webp";